require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-meet-the-brand-behind-the-worlds-most-liveable-suburb.json") })
        }
      }, "path---news-meet-the-brand-behind-the-worlds-most-liveable-suburb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-meet-the-brand-behind-the-worlds-most-liveable-suburb!./.cache/json/news-meet-the-brand-behind-the-worlds-most-liveable-suburb.json
// module id = 829
// module chunks = 231608221292675